import { render, staticRenderFns } from "./StickerVideoMuteButton.vue?vue&type=template&id=077d86d8&scoped=true"
import script from "./StickerVideoMuteButton.vue?vue&type=script&lang=ts"
export * from "./StickerVideoMuteButton.vue?vue&type=script&lang=ts"
import style0 from "./StickerVideoMuteButton.vue?vue&type=style&index=0&id=077d86d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077d86d8",
  null
  
)

export default component.exports